<template>
  <vs-popup
    fullscreen
    title="Add/Update Lesson"
    :active.sync="isPopupActiveLocal"
  >
    <!-- {{courseData}} -->
    <!-- {{lessonData}} -->
    <!-- <div class="vx-row">
      <div class="vx-col md:w-full w-full"> -->
    <!-- <vs-card> -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <!-- {{existingVideo}} -->
        <!-- <vs-card class="mt-3"> -->
        <!-- <label class="mb-3" > Add new lessons</label><br/> -->
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label="Lesson title"
              name="item-title"
              v-model="lessonTitle"
            />
          </div>
        </div>

        <div class="vx-row ">
          <div class="vx-col w-full">
            <vs-textarea
              label="Lesson Description"
              v-model="lessonDescription"
            />
          </div>
        </div>

        <div class="vx-row mb-6">
          <vs-checkbox
            v-if="existingModule.length !== 0"
            v-model="enableModuleList"
            class="mb-3 ml-4"
            >Choose existing module</vs-checkbox
          >
          <div class="vx-col w-full">
            <vs-input
              v-if="!enableModuleList"
              class="w-full"
              label="Module Name"
              name="item-Module"
              v-model="moduleName"
            />

            <vs-select
              v-if="enableModuleList"
              v-model="moduleName"
              class="w-full select-large"
              label="Module Name"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in existingModule"
                class="w-full"
              />
            </vs-select>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label="Lesson Start time (T+)"
              name="item-name"
              v-model="lessonStartTime"
            />
          </div>
        </div>

        <!-- <div>
          <vs-button
          @click="stopUploading"
          >
            Stop
          </vs-button>
        </div> -->

        <!-- </vs-card> -->
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <div
          class="vx-row mb-3 mt-6"
          v-if="existingVideo && existingVideo.length !== 0"
        >
          <div class="vx-col  w-full">
            <vs-checkbox
              v-if="existingVideo.length !== 0"
              v-model="enableVideoList"
              class=" ml-4"
              >Choose existing video</vs-checkbox
            >           
            
          </div>
           <div class="vx-col  w-full mt-6">
            <label v-if="enableVideoList" >Video Name</label>
            <v-select
              v-if="enableVideoList"
              v-model="videoInfo"
              :clearable="false"
              :options="existingVideo"              
              name="status"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
            </div>

          <!-- <div class="vx-col md:w-3/5 w-full"> -->
            
            <!-- <vs-select
              v-if="enableVideoList"
              v-model="videoInfo"
              class="w-full select-large"
              :text="selectedItem"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in existingVideo"
                class="w-full"
              />
            </vs-select> -->
          <!-- </div> -->
        </div>
        <!-- <div v-if="existingVideo && existingVideo.length === 0"> -->
        <div v-if="!enableVideoList">
          <div v-if="!existingUrl && !videoInfo">
            <div class="vx-row mb-6">
              <div class="vx-col  w-full">
                <vs-input
                  class="w-full"
                  label="Video Name"
                  name="video-name"
                  v-model="videoName"
                />
              </div>
            </div>
            
            <div class="vx-row mb-1">
              <div class="vx-col  w-full">
                <vs-textarea
                  v-model="videoDescription"
                  class="w-full"
                  label="Description"
                  name="video-description"
                />
              </div>
              <label class="my-0 mx-3">* Video name and Description are required to upload video</label>
            </div>
          </div>
        </div>

        <div class="vx-row mb-3">
          <input
            type="file"
            class="hidden"
            ref="uploadVidInput"
            @change="updateCurrVid"            
            accept="video/*"
          />
          <vs-button
            v-if="!file && !videoUrl && !existingUrl && !enableVideoList"
            @click="$refs.uploadVidInput.click()"
            :disabled="!isUploadValid"
            class="ml-3 "
            >Upload Video</vs-button
          >
        </div>
        <div class="vx-row w-full mb-3 ml-2" v-if="file && !videoUrl">
          <span>{{ file.name }}</span>
          <feather-icon
            icon="XIcon"
            @click="removeUploadedFile"
            class="cursor-pointer"
          ></feather-icon>
        </div>

        <div class="vx-row mb-3 w-full">
          <vs-button
            v-if="file && progress !== 100"
            @click="uploadToCdn"
            class="mx-3"
            >Upload to Server</vs-button
          >
        </div>

        <div v-if="uploading" class="progress-bar">
          <div class="demo-vertical-spacing mb-3">
            <div class="progress-wrapper">
              <div class="mb-0">Uploading {{ progress + '%' }}</div>

              <vs-progress
                :percent="progress"
                color="primary"
                :height="8"
              ></vs-progress>
            </div>
          </div>
        </div>

        <div v-if="videoUrl || existingUrl || videoInfo">
          <div>
            
          </div>
          <div class=" mb-3 ml-2 w-full mt-3" v-if="videoInfo && videoInfo.value">
            <label class="mb-3 ">Linked Video :</label>
            <p class="mb-1">Video name: {{ videoInfo.value.videoName }}</p>
            <p v-if="videoInfo.value.videoUrl">
              Video Url: {{ videoInfo.value.videoUrl.substr(34, 30) }}
            </p>
            <vs-button @click="removeUploadedVideoInfo" class="my-3"
              >remove</vs-button
            >
          </div>
           <div class=" mb-3 ml-2 w-full mt-3" v-if="videoUrl">
            <!-- <p >
              Video Url: {{videoUrl.substr(34, 13) }}
            </p> -->
            <div class="mb-3">
            <label>Uploaded Video :</label>
          </div>
            
            <vs-chip
                color="primary"
                closable
                @click="removeUploadedVideoInfo"
              >
                <span v-if="videoUrl">{{ videoUrl.substr(34, 30) }}</span>
                <!-- <span v-if="existingUrl">{{ existingUrl.substr(29, 13) }}</span> -->
              </vs-chip>
            <!-- <vs-button @click="removeUploadedVideoInfo" class="my-3"
              >remove</vs-button
            > -->
          </div>
          <!-- <div class="vx-row mb-3 ml-2 w-full mt-3">
              
            </div> -->
        </div>

        
        <!-- <div class="vx-row w-full mb-6 ml-2" v-if="uploadedDocs">
          <span >{{doc.name}}</span>
          <feather-icon icon="XIcon" @click="removeUploadedDoc" class="cursor-pointer"></feather-icon>
        </div> -->
      </div>
    </div>
    <div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-checkbox v-model="isNotes" class="mb-3 ">Notes</vs-checkbox>
          <vue-editor v-model="notes" :disabled="!isNotes"></vue-editor>
        </div>
      </div>
      <div class="mb-3">
        <label class="mt-3 ml-3 mb-0">Downloadable Notes</label><br/>
        <input
          type="file"
          class="hidden"
          ref="uploadDocInput"
          multiple
          @change="updateCurrDoc"
        />
        <!-- accept=".pdf,.doc, .docx" -->
        <vs-button @click="$refs.uploadDocInput.click()" class="my-3 mt-3"
          >Upload Docs</vs-button
        >
        <!-- Listing doc files uploaded -->
        <template v-if="uploadedDocs" class="vx-row mb-3">
          <div :data="tr" :key="indextr" v-for="(tr, indextr) in uploadedDocs">
            <!-- <div class=" w-64 mx-auto flex items-center justify-center"> -->
            <div class="  flex items-center">
              <span>{{ tr.name }}</span>
              <feather-icon
                icon="XIcon"
                @click="removeUploadedDoc(indextr)"
                class="cursor-pointer"
              ></feather-icon>
            </div>
          </div>
        </template>

        <!-- Listing doc urls names from DB -->
        <template v-if="dataDocs" class="vx-row mb-3">
          <!-- <label> uploaded docs</label> -->
          <div :data="tr" :key="indextr" v-for="(tr, indextr) in dataDocs">
            <!-- <div class=" w-64 mx-auto flex items-center justify-center"> -->
            <div class=" mt-3">
              <vs-chip color="primary" closable @click="removeOldDoc(indextr)">
                <span v-if="tr.name">{{ tr.name.substr(19) }}</span>
                <!-- <feather-icon icon="XIcon" @click="removeOldDoc(indextr)" class="cursor-pointer"></feather-icon> --> </vs-chip
              ><br />
            </div>
          </div>
        </template>
        
        
      </div>
      <div class="vx-row mb-3">
        <vs-checkbox v-model="isEnabled" class="mb-3 ml-6 mt-6"
          >Enable Lesson</vs-checkbox
        >
      </div>

      <div class="vx-row">
        <div class="vx-col">
          <vs-button
            class="mt-3 mb-2 w-full"
            @click="submitData"
            :disabled="!isFormValid"
            >Add lesson</vs-button
          >
        </div>
      </div>
    </div>
    <!-- </vs-card> -->
    <!-- </div>
    </div> -->
  </vs-popup>
</template>

<script>
// import moduleCategoryManagement from '@/store/categories/moduleCategoryManagement.js'
/* eslint-disable */
import { VueEditor } from 'vue2-editor'
import vSelect from 'vue-select'

import axios from 'axios'
import { BProgress } from 'bootstrap-vue'
export default {
  props: {
    isPopupActive: {
      type: Boolean,
      required: true
    },
    courseData: {
      type: String
      // default: () => {}
    },
    lessonData: {
      type: Object,
      default: () => {}
    },
    existingModule: {
      type: Array
      // default: () => {}
    },
    existingVideo: {
      type: Array
      // default: () => {}
    }
  },
  components: {
    BProgress,
    VueEditor,
    vSelect
  },
  data() {
    return {
      // upload video vars
      checkVideo: false,
      uploading: false,
      progress: 0,
      file: null,
      videoUrl: null,
      existingUrl: null,
      pathName: null,
      cancelTokenSource: null,
      videoName: null,
      videoDescription: null,

      //notes vars
      notes: '',
      isNotes: false,
      //uplaod docs var
      uploadedDocs: [],
      dataDocs: [],

      dataId: null,
      courseId: null,
      lessonTitle: null,
      lessonDescription: null,
      moduleName: null,
      lessonStartTime: 0,
      dataVid: null,
      enableModuleList: false,
      enableVideoList: false,
      videoInfo: null,
      selectedItem: 'Select videos',

      isEnabled: false,

      lessons: [
        {
          name: 'name1',
          duration: 5,
          description: 'new desc'
        },
        {
          name: 'name1',
          duration: 5,
          description: 'new desc'
        },
        {
          name: 'name1',
          duration: 5,
          description: 'new desc'
        }
      ]

      // existingModule: [
      //   {text:'Module1', value:'Module1'},
      //   {text:'Module2', value:'Module2'},
      //   {text:'Module3', value:'Module3'},
      //   {text:'Module3', value:'Module3'}
      // ]
    }
  },
  watch: {
    isPopupActive(val) {
      if (!val) {
        this.initValues()
        return
      }
      if (Object.entries(this.lessonData).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {
          id,
          courseId,
          title,
          description,
          moduleName,
          startTime,
          videoUrl,
          notes,
          attachments,
          isEnabled,
          videoInfo
        } = JSON.parse(JSON.stringify(this.lessonData))
        this.dataId = id
        this.courseId = courseId
        this.lessonTitle = title
        this.lessonDescription = description
        this.moduleName = moduleName
        this.lessonStartTime = startTime
        // this.existingUrl = videoUrl
        if (notes && notes !== 'No Notes') {
          this.isNotes = true
          this.notes = notes
        }
        this.dataDocs = attachments
        this.isEnabled = isEnabled
        if (videoInfo && videoInfo.length) {
          this.videoInfo = {
            label: videoInfo[0].videoName,
            value: videoInfo[0]
          }
          this.enableVideoList = true
        }

        // this.initValues()
      }
    },
    videoInfo(val) {
      if (!val) return
      if (val) {
        // console.log('val.value', val.value.videoUrl)
        this.existingUrl = val.value.videoUrl
        this.pathName = val.value.path
        this.selectedItem = val.value.videoName
      }
    },
    enableVideoList(val) {
      if(!val){
        this.removeUploadedVideoInfo()
      } else {
        this.videoUrl = null
        this.videoName = null
        this.videoDescription = null
        this.file = null
      }
    }
  },
  computed: {
    isPopupActiveLocal: {
      get() {
        return this.isPopupActive
      },
      set(val) {
        if (!val) {
          this.$emit('closePopup')
          this.progress = 0
          this.uploading = 0
          this.dataVid = null

          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid() {
      return (
        this.lessonTitle &&
        this.lessonDescription &&
        this.moduleName &&
        this.lessonStartTime >= 0,
        (this.videoUrl || this.existingUrl)
      )
    },
    isUploadValid() {
      return (
        this.videoName &&
        this.videoDescription       
      )
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    initValues() {
      // if (this.data.id) return
      this.dataId = null
      this.lessonTitle = null
      this.lessonDescription = null
      this.moduleName = null
      this.lessonStartTime = null
      this.enableModuleList = false
      this.dataVid = null
      this.file = null
      this.progress = 0
      this.videoUrl = null
      this.existingUrl = null
      this.pathName = null
      this.notes = null
      this.isNotes = false
      this.uploadedDocs = []
      this.dataDocs = []
      this.isEnabled = false
      this.videoInfo = null
      this.enableVideoList = false
      this.videoName = null
      this.videoDescription = null
    },
    uploadToCdn() {
      try {
        this.$validator.validateAll().then(async (result) => {
          if (result) {
            //  File Upload Logic
            this.uploading = true
            const getConfig = await this.$store
              .dispatch('courses/fetchStorageDetails')
              .catch((error) => {
                console.log('error in getting config details:', error)
                this.errorMsg('config details not found')
              })
            const config =
              getConfig && getConfig.data ? getConfig.data : undefined
            //console.log('debug 0: ' + JSON.stringify(config))

            // console.log('debug 1: ' + JSON.stringify(getConfig.data))
            if (!config || !this.file) {
              this.errorMsg('config or file not found')
              throw new Error('config or file not found')
              return
            }

            // file upload

            var axiosClient = axios.create({
              baseURL: config.storageUrl
            })
            delete axiosClient.defaults.headers.common['Authorization']

            // console.log('file name', this.file.name, config.code)
            // create stream file and get file id
            const createResponse = await axiosClient({
              method: 'POST',
              url: '/videos',
              data: {
                title: this.file.name
              },
              headers: {
                AccessKey: config.code
              }
            }).catch((error) => {
              console.log('error in getting response details:', error)
              this.errorMsg('response details not found')
            })

            if (
              createResponse &&
              createResponse.status == 200 &&
              createResponse.data
            ) {
              // file upload
              const file_upload_url =
                config.storageUrl + '/videos/' + createResponse.data.guid
              const file_cdn_url =
                config.cdnUrl +
                '/' +
                createResponse.data.guid +
                '/playlist.m3u8'
              this.cancelTokenSource = axios.CancelToken.source()
              try {
                const uploadResponse = await axiosClient({
                  method: 'PUT',
                  url: file_upload_url,
                  data: this.file,
                  headers: {
                    AccessKey: config.code,
                    'Content-Type': 'video/x-m4v'
                  },
                  cancelToken: this.cancelTokenSource.token,
                  onUploadProgress: (e) =>
                    (this.progress = Math.round((e.loaded * 100) / e.total))
                })
                // console.log("uploadResponse",uploadResponse)
                if (uploadResponse && uploadResponse.status == 200) {
                  this.successMsg('Video uploaded successfully')
                  this.uploading = false
                  // this.progress= 0
                  this.videoUrl = file_cdn_url
                  this.pathName = createResponse.data.guid
                  // console.log('debug cdn url: ' + file_cdn_url)
                }
              } catch (err) {
                console.log('failed: upload to server-->', err)
                this.errorMsg('failed: network error')
              }
            } else {
              this.errorMsg('failed to uplooad')
              throw new Error('failed to create videoPath,upload error! ')
            }
          } else {
            console.log('validation error:result not found')
          }
        })
      } catch (err) {
        console.log('add lesson error: ' + err)
        this.errorMsg(err)
      }
    },
    submitData() {
      this.$vs.loading()
      try {
        this.$validator.validateAll().then(async (result) => {
          if (result) {
            const obj = {
              // videoUrl: this.videoUrl,
              path: this.pathName,
              id: this.dataId,
              title: this.lessonTitle,
              description: this.lessonDescription,
              moduleName: this.moduleName,
              startTime: this.lessonStartTime,
              isEnabled: this.isEnabled
            }

            if (this.videoUrl) {
              obj.videoUrl = this.videoUrl
              obj.videoName = this.videoName
              obj.videoDescription = this.videoDescription
            } else if (this.existingUrl) {
              obj.videoUrl = this.existingUrl
              obj.isProcessed = true
            }

            //if notes
            if (this.isNotes) {
              obj.notes = this.notes
            }

            // If new docs
            if (this.uploadedDocs.length !== 0) {
              obj.docs = this.uploadedDocs
            }

            // // on change of old docs
            // if(this.dataDocs.length !==0) {
            //   obj.oldDocs = this.dataDocs
            // }

            if (this.dataId !== null) {
              obj.courseId = this.courseId
              obj.oldDocs = this.dataDocs
              console.log('lesson to be updated', obj)
              this.$store
                .dispatch('courses/updateLesson', obj)
                .then((response) => {
                  this.$vs.loading.close()
                  this.successMsg(response.data.data)
                })
                .catch((err) => {
                  this.$vs.loading.close()
                  console.error(err)
                  this.errorMsg(err)
                })
            } else {
              // delete obj.id
              //obj.popularity = 0
              obj.courseId = this.courseData
              console.log('lesson to craete', obj)

              // obj.videoUrl = 'video_url'
              // obj.path = 'video_path'
              this.$store
                .dispatch('courses/addLesson', obj)
                .then((response) => {
                  this.$vs.loading.close()
                  this.successMsg(`${response.data.data.title} added`)
                })
                .catch((err) => {
                  this.$vs.loading.close()
                  console.error(err)
                  this.errorMsg(err)
                })
            }
            this.$emit('closePopup')
            this.initValues()
          }
        })
      } catch (err) {
        console.log('add lesson error: ' + err)
      }
    },

    stopUploading() {
      this.cancelTokenSource
        .cancel('upload cancelled')
        .then(() => {
          {
            this.successMsg('uploading cancelled')
          }
        })
        .catch((err) => {
          console.log('error in stopping upload:', err)
        })
    },
    removeUploadedFile() {
      this.file = null
      this.dataVid = null
    },
    removeUploadedDoc(input) {
      this.uploadedDocs.splice(input, 1)
      // console.log('final uploaded doc list', this.uploadedDocs)
    },
    removeOldDoc(input) {
      this.dataDocs.splice(input, 1)
      // console.log('final old doc list', this.dataDocs)
    },
    removeUploadedVideoInfo() {
      this.videoUrl = null
      this.existingUrl = null
      this.file = null
      this.dataVid = null
      this.progress = 0
      this.videoInfo = null
    },
    updateCurrVid(input) {
      if (input.target.files && input.target.files[0]) {
        this.file = input.target.files[0]
      }
    },
    updateCurrDoc(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        this.uploadedDocs = [...this.uploadedDocs, ...input.target.files]
        // console.log('multiple docs', this.uploadedDocs)
        // reader.onload = e => {
        //   this.uplaodedFiles = e.target.result
        // }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    successMsg(message) {
      this.$vs.notify({
        title: 'Success',
        text: message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    errorMsg(errMsg) {
      this.$vs.notify({
        title: 'Failed',
        text: errMsg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    }
  }
  // created () {
  //   if (!moduleCategoryManagement.isRegistered) {
  //     this.$store.registerModule('categories', moduleCategoryManagement)
  //     moduleCategoryManagement.isRegistered = true
  //   }
  //   this.$store.dispatch('categories/fetchCategories')
  // }
}
</script>
